import React from "react";
import "./mission.css";
import hospitalImg from "../Assets/aboutus-4.png"; // Replace with your actual path

const MissionVision = () => {
  return (
    <div className="mission-vision-container">
      <div className="text-section">
        <div className="box">
          <h3>Mission</h3>
          <p>
            To provide quality health care services at affordable costs while
            seeking to generate good financial performance & appropriate returns
            to stakeholders.
          </p>
        </div>
        <div className="box">
          <h3>Vision</h3>
          <p>
            To expand our health care facility so as to provide accessible,
            affordable and best available health care services.
          </p>
        </div>
        <div className="box">
          <h3>Core Values</h3>
          <ul>
            <li>+ Patient Centered Care</li>
            <li>+ Integrity</li>
            <li>+ Excellence</li>
            <li>+ Innovation</li>
          </ul>
        </div>
      </div>
      <div className="image-section">
        <img src={hospitalImg} alt="hospital" />
      </div>
    </div>
  );
};

export default MissionVision;
